import { render } from "./Trainer.vue?vue&type=template&id=2f9dec43&scoped=true&ts=true"
import script from "./Trainer.vue?vue&type=script&lang=ts"
export * from "./Trainer.vue?vue&type=script&lang=ts"

import "./Trainer.vue?vue&type=style&index=0&id=2f9dec43&lang=scss&scoped=true"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9dec43"]])

export default __exports__